import React, { createContext, useContext, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
// Step 1: Create a Context
const RouteNameContext = createContext();

// Step 2: Create a Provider Component
export const RouteNameProvider = ({ children }) => {
  // const [unsavedChanges, setUnsavedChanges] = useState(false);
   // Manage driverState here in the parent component
   const [driverState, setDriverState] = useState({
    driver: null,
    route_name: null,
  });


  return (
    <RouteNameContext.Provider
      value={{
        driverState,
        setDriverState,
      }}
    >
      {children}
    </RouteNameContext.Provider>
  );
};

RouteNameProvider.propTypes = {
  children: PropTypes.node.isRequired, // children is required and should be a React node
};

// Step 3: Use the Context in your Components
export const useRouteNameChanges = () => useContext(RouteNameContext);
